import { PdfCellType } from './pdf-cell-type.enum';

export class PdfColDef {

    header: string;
    type: PdfCellType;
    width: string;

    constructor(header: string, type?: PdfCellType, width?: string) {
        this.header = header;
        this.type = type ? type : PdfCellType.TEXT;
        this.width = width ? width : 'auto';
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pdf/pdf-col-def.ts